import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { LOCATION_CITY } from '../../constants/endpoint.const';
import { LocationProvinceRequest } from '../../models/locations.model';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(private baseService: BaseService) {}

  getCity(params: LocationProvinceRequest) {
    return this.baseService.getData(LOCATION_CITY, params, null);
  }
}
